import apiService from './apiService';

const STORAGE_KEY = 'rahber_showroom_inquiries';

export function getLocalInquiries() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        return JSON.parse(raw);
    } catch {
        return [];
    }
}

export function saveLocalInquiry(inquiry) {
    try {
        const list = getLocalInquiries();
        const updated = [
            {
                ...inquiry,
                id: inquiry.id || inquiry.referenceId || `RC-${Date.now().toString().slice(-6)}`,
                createdAt: inquiry.createdAt || new Date().toISOString(),
                status: inquiry.status || 'New',
            },
            ...list,
        ];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
    } catch (e) {
        console.warn('Failed to save inquiry locally:', e);
        return [];
    }
}

export function updateInquiryStatus(id, newStatus) {
    try {
        const list = getLocalInquiries();
        const updated = list.map((item) =>
            item.id === id || item.referenceId === id ? { ...item, status: newStatus } : item
        );
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
    } catch {
        return [];
    }
}

export function deleteLocalInquiry(id) {
    try {
        const list = getLocalInquiries();
        const updated = list.filter((item) => item.id !== id && item.referenceId !== id);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
    } catch {
        return [];
    }
}

/**
 * Submits the public ecommerce contact form (no auth)
 * Also saves to local showroom dashboard storage for immediate viewing.
 */
export async function submitContact(payload) {
    // Save to local showroom store immediately
    const refCode = payload.referenceId || Math.floor(100000 + Math.random() * 900000).toString();
    saveLocalInquiry({
        ...payload,
        referenceId: refCode,
        createdAt: new Date().toISOString(),
        status: 'New',
    });

    try {
        return await apiService.post('/ecommerce/contact', payload);
    } catch (err) {
        console.warn('Backend API offline or error, inquiry saved locally for showroom dashboard:', err);
        return { data: { success: true, localOnly: true } };
    }
}

